module.exports = __webpack_public_path__ + "img/icon310.d30275ac.png";